import { onboardingData } from './data/onboardingData';
import { getStorageObject } from './global';

export const initializeOnboardingFormData = (formKey, validationSchema, defaultState) => {
  const savedData = getStorageObject('onboarding-form-data');
  if (savedData?.[formKey] && !validationSchema.validate(savedData?.[formKey]).error) {
    return savedData[formKey];
  }
  return defaultState;
};

export const checkOnboardingStep = (code, step) => {
  const data = onboardingData.find((d) => d.code === code);
  if (!data) return false;
  return data.step === step;
};

export const getOnboardingData = (code) => {
  return onboardingData.find((d) => d.code === code);
};
